import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';
const config = require('../configs/config');
// import modules
import taskModule from './TaskStore';
import statModule from './StatStore';
import userModule from './UserStore';
import quotationModule from './QuotationStore';

Vue.use(Vuex);

const BASE_URL = config.apiUrl;
const store = new Vuex.Store({
  state: {
    tasks: [],
    stats: [],
    count: 10,
    quotations: [],
    users: []
  },
  modules: {
    taskModule,
    statModule,
    quotationModule,
    userModule,
  },
  mutations: { // got state
    add_entity(state, payload) {
      state[payload.entityName] = [...state[payload.entityName], Object.assign({}, payload.entity)];
    },
    add_entities(state, payload) {
      state[payload.entityName] = [...state[payload.entityName], ...Object.assign([], payload.entities)];
    },
    replace_entity(state, payload) {
      state[payload.entityName] = state[payload.entityName].filter(e => e._id !== payload.entity._id);
      state[payload.entityName] = [...state[payload.entityName], Object.assign({}, payload.entity)];
    },
    remove_entity(state, payload) {
      state[payload.entityName] = state[payload.entityName].filter(e => e._id !== payload.entity._id);
    },
    set_entities(state, payload) {
      state[payload.entityName] = Object.assign([], payload.entities);
    },
    increment(state) {
      state.count++
    },
    decrement(state) {
      state.count--
    }
  },
  actions: { // got context for commit
    postEntity({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(BASE_URL + payload.url, payload.entity)
          .then(response => {
            commit('add_entity', {
              entityName: payload.entityName,
              entity: response.data
            });
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    putEntity({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(BASE_URL + payload.url, payload.entity)
          .then(response => {
            commit('replace_entity', {
              entityName: payload.entityName,
              entity: response.data
            });
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteEntity({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios
          .delete(BASE_URL + payload.url)
          .then(response => {
            // data == deletion result
            if (response.data) {
              commit('remove_entity', payload);
            }
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getEntity({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(BASE_URL + payload.url)
          .then(response => {
            commit('replace_entity', {
              entityName: payload.entityName,
              entity: response.data
            });
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAllEntity({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(BASE_URL + payload.url)
          .then(response => {
            commit('set_entities', {
              entityName: payload.entityName,
              entities: response.data
            });
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  }
});

export default store;
